import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {};

export const mutations = {};

export const actions = {
  async acAmountFailLog(
    {},
    { imp_uid, merchant_uid, error_msg, pg_name, payment_funnel }
  ) {
    const url = `/api/v1/amount-fail-log`;
    const params = {
      imp_uid,
      merchant_uid,
      pg_name,
      payment_funnel,
      error_msg,
      error_code: -9826,
    };
    console.log("failkfai", params);
    try {
      await api.post(url, params);
      return null;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
